import { render } from "./LicencesDistributionRenewCart.vue?vue&type=template&id=4f5c0674"
import script from "./LicencesDistributionRenewCart.vue?vue&type=script&lang=js"
export * from "./LicencesDistributionRenewCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__